import React, { memo, useEffect, useRef, useState } from "react";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useDispatch, useSelector } from "react-redux";
import { getData, setsearch } from "../../redux/actions/menu";
import MenuCard from "../../components/card/MenuCard";
import FilterCard from "../../components/card/FilterCard";
import BannerMenu from "../../components/banners/BannerMenu";
import vegBadge from "../../media/images/veg-badge.webp";
import veganBadge from "../../media/images/vegan-badge.webp";
import nonVegBadge from "../../media/images/non-veg-badge.webp";
import { capitalizeFLetter } from "../../functions/conversion";
import { useParams } from "react-router-dom";
import SplashScreen from "../../layout/SplashScreen";
import SpeedDial from "../../components/SpeedDial";

function Menu() {
  const dispatch = useDispatch();
  const { section } = useParams();
  const { activeOutlet } = useSelector((state) => state.config);

  const { filterData, sectionData, menuData, search } = useSelector((state) => state.menu);

  const sectionFilterRef = useRef(sectionData);
  const [sectionDisplayData, setsectionDisplayData] = useState(sectionData);

  const [activeFilter, setactiveFilter] = useState([]);
  const [moreInfo, setmoreInfo] = useState({});
  const [moreInfoPopup, setmoreInfoPopup] = useState(false);
  const [speedDialOpen, setspeedDialOpen] = useState(false);

  useEffect(() => {
    return () => {
      dispatch(setsearch(""));
    };
  }, []);

  function onClickFilter(item) {
    if (activeFilter.includes(item.id)) {
      const removeFilter = activeFilter.filter((itemFilter) => itemFilter !== item.id);
      setactiveFilter(removeFilter);
    } else {
      setactiveFilter((prev) => [...prev, item.id]);
    }
  }

  useEffect(() => {
    function checkFilter(menu) {
      return menu.filter((item) => {
        let isAvailabke = false;
        menuData[item].filters.map((filter) => {
          if (activeFilter.includes(filter)) {
            isAvailabke = true;
          }
        });
        return isAvailabke;
      });
    }

    const createFilteredSection = () => {
      let filteredArray = [];

      const sectionArray = JSON.parse(JSON.stringify(sectionData));
      filteredArray = sectionArray.map((item) => ({ ...item, menu: checkFilter(item.menu) }));

      return filteredArray;
    };

    if (activeFilter.length === 0) {
      setsectionDisplayData(sectionData);
      sectionFilterRef.current = sectionData;
    } else {
      const filteredData = createFilteredSection();
      setsectionDisplayData(filteredData);
      sectionFilterRef.current = filteredData;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeFilter]);

  function checkEmptyMenu() {
    let isEmpty = true;

    for (let i = 0; i < sectionDisplayData.length; i++) {
      if (sectionDisplayData[i].menu.length > 0) {
        isEmpty = false;
        break;
      }
    }
    return isEmpty;
  }

  if (!activeOutlet) {
    return null;
  }

  return (
    <div className="menu-page">
      <BannerMenu />

      {filterData.length ? (
        <div className="filters">
          {filterData.map(
            (item, index) =>
              item.visible && (
                <FilterCard
                  key={item.id}
                  img={item.img}
                  name={item.name}
                  onClick={() => onClickFilter(item)}
                  className={activeFilter.includes(item.id) ? "filter-card-active" : ""}
                />
              )
          )}
        </div>
      ) : null}

      <div className="menu-container">
        {!checkEmptyMenu() ? (
          section ? (
            <SectionComponent
              data={sectionDisplayData.filter((item) => item.id === section)[0]}
              dataMenu={sectionDisplayData.filter((item) => item.id === section)[0].menu.map((item) => menuData[item])}
              setmoreInfo={setmoreInfo}
              setmoreInfoPopup={setmoreInfoPopup}
            />
          ) : (
            sectionDisplayData.map((section) => (
              <SectionComponent
                key={section.id}
                data={section}
                dataMenu={section.menu.map((item) => menuData[item])}
                setmoreInfo={setmoreInfo}
                setmoreInfoPopup={setmoreInfoPopup}
              />
            ))
          )
        ) : (
          <div className="empty-menu">
            <p className="message">No items found 🍕</p>
            <div
              to="/"
              className="btn"
              onClick={() => {
                dispatch(setsearch(""));
                setactiveFilter([]);
              }}
            >
              <p>See all menu items</p>
            </div>
          </div>
        )}
      </div>

      {!section && (
        <SpeedDial
          data={sectionData.map((item) => ({ name: item.name, isVisible: item.menu.length && item.visible }))}
          onClick={() => {
            setspeedDialOpen((prev) => !prev);
          }}
          active={speedDialOpen}
          onClose={() => {
            setspeedDialOpen(false);
          }}
        />
      )}
      <MoreInfoComponent data={moreInfo} setdata={setmoreInfo} active={moreInfoPopup} setactive={setmoreInfoPopup} />
    </div>
  );
}

const SectionComponent = memo((props) => {
  const { data, dataMenu, setmoreInfo, setmoreInfoPopup } = props;

  const [displayDataMenu, setdisplayDataMenu] = useState(dataMenu);

  useEffect(() => {
    setdisplayDataMenu(dataMenu);
  }, [dataMenu]);

  const { search } = useSelector((state) => state.menu);

  useEffect(() => {
    if (search === "") {
      setdisplayDataMenu(dataMenu);
    } else {
      // let newMenuObj = {};
      // sectionData.forEach((section) => {
      //   newMenuObj = {
      //     ...newMenuObj,
      //     [section.ref]: menuFixed[section.ref].filter((item) =>
      //       item.name.toLowerCase().includes(debouncedSearch.toLowerCase())
      //     ),
      //   };
      // });

      // dispatch(setmenuData(newMenuObj));

      const searchedData = dataMenu.filter((item) => item.name.toLowerCase().includes(search.toLowerCase()));
      setdisplayDataMenu(searchedData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  return (
    displayDataMenu.length !== 0 && (
      <div className="section" id={data.name}>
        <div className="header">
          <h3>{data.name}</h3>
        </div>
        <div className="menu-items">
          {displayDataMenu.map(
            (item) =>
              item.visible && (
                <MenuCard key={item.id} data={item} setmoreInfo={setmoreInfo} setmoreInfoPopup={setmoreInfoPopup} />
              )
          )}
        </div>
      </div>
    )
  );
});

const MoreInfoComponent = (props) => {
  const { data, setdata, active, setactive } = props;

  const { activeOutlet } = useSelector((state) => state.config);

  useEffect(() => {
    if (!active) {
      setTimeout(() => {
        setdata({});
      }, 300);
    }
  }, [active]);

  return (
    <div className={`more-info-popup ${active ? "active" : ""}`} onClick={() => setactive(false)}>
      <div className="more-info-container" onClick={(e) => e.stopPropagation()}>
        <div className="img">
          <img src={data.img} alt={data.name} />
        </div>

        <div className="details">
          <h2 className="grey mb-2">{data.name}</h2>
          {data.description && <p className="mb-2">{data.description}</p>}

          <div className="flex g-2">
            <div className="price">
              <p>{activeOutlet.outletCurrency}</p>
              <h2>{data.price ? data.price.toFixed(2) : ""}</h2>
            </div>

            {data.bestseller && <div className="best-seller">BESTSELLER</div>}
            {data.type && (
              <div className="flex g-1">
                <div className="badge">
                  {data.type === "veg" && <img src={vegBadge} alt="veg badge" />}
                  {data.type === "vegan" && <img src={veganBadge} alt="vegan badge" />}
                  {data.type === "nonveg" && <img src={nonVegBadge} alt="non-veg badge" />}
                </div>
                <p>{capitalizeFLetter(data.type)}</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Menu;
